module.exports = "../static/media/SweetWatch-btn.8eba55c5.png";